import { useNavigate } from 'react-router-dom';
import ManualController from '../../../hoc/ManualController';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { MainContext } from '../../../context/main.context';
import { cancelPaymentInqud, createPaymentInqud } from '../../../stores/payment.store';
import {
    PAYMENTS_INQUD_CLOSE_WIDGET_ERROR,
    PAYMENTS_INQUD_CREATE_ERROR,
} from '../../../common/errorCodes';
import Payments from '../index';
import Loader from '../../loader';


export default function PaymentsInqud() {
    const navigate = useNavigate();
    const { manualRedirect } = ManualController();
    const { modalContent, paymentId, locale, project, source, jwt, toggleLoader, setModalContent } = useContext(MainContext);

    const [ checkoutId, setCheckoutId ] = useState<string>('');

    const scriptRef = useRef<HTMLScriptElement | null>(null);
    const widgetRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!checkoutId || !widgetRef.current) {
            return;
        }

        widgetRef.current.innerHTML = `<app-widget id="${checkoutId}"></app-widget>`;

        const widget = widgetRef.current.querySelector('app-widget');

        if (!widget) {
            console.log('Виджет не найден')
            return;
        }

        widget.addEventListener('statusChanged', _handleCheckoutStatusChange);

        return () => {
            widget.removeEventListener('statusChanged', _handleCheckoutStatusChange);
        };
    }, [ checkoutId ]);

    useEffect(() => {
        _createWidget();

        return () => {
            if (scriptRef?.current) {
                document.body.removeChild(scriptRef.current);
                scriptRef.current = null;
            }
        };
    }, []);

    const _createWidget = () => {
        const script = document.createElement('script');
        script.src = process.env.REACT_APP_INQUD_SRC as string;
        script.defer = true;
        script.onload = () => _createPayment();

        document.body.appendChild(script);
        scriptRef.current = script;
    }

    const _createPayment = (): void => {
        toggleLoader(true);

        const id: string = paymentId as string;

        createPaymentInqud(id).then(res => {
            const { checkoutId } = res.data;

            if (!checkoutId) {
                manualRedirect(res, 'payment', true, PAYMENTS_INQUD_CREATE_ERROR);
                return;
            }

            setCheckoutId(checkoutId);
        }, err => {
            const errData = err?.response?.data || err;
            manualRedirect(errData, 'payment', true, PAYMENTS_INQUD_CREATE_ERROR);
        }).finally(() => {
            toggleLoader(false);
        });
    }



    const _navigate = (path: string): void => {
        navigate({
            pathname: path,
            search: `?id=${paymentId}&source=${source}&locale=${locale}&project=${project}&jwt=${jwt}`,
        });
    }

    const _onClose = (): void => {
        toggleLoader(true);

        cancelPaymentInqud(checkoutId).then(res => {
            const result = res?.data?.result;

            if (result) {
                if (modalContent) {
                    setModalContent({ component: <Payments/> });
                    return;
                }

                _navigate('/payments/process');
                return;
            }

            manualRedirect(res, 'payment', true, PAYMENTS_INQUD_CLOSE_WIDGET_ERROR);
        }, err => {
            const errData = err?.response?.data || err;
            manualRedirect(errData, 'payment', true, PAYMENTS_INQUD_CLOSE_WIDGET_ERROR);
        }).finally((): void => {
            toggleLoader(false);
        });
    }

    const _handleCheckoutStatusChange = (event: any) => {
        const checkoutId = event?.detail?.id;
        const status = event?.detail?.status;

        console.log(`Callback Invoked: checkoutId=${checkoutId}, status=${status}`);

        if (status === 'SUCCESS') {
            console.log('Payment Successful');
            // например:
            // navigate('/success');
        } else if (status === 'CONFLICT') {
            console.log('Payment Conflict');
        }
    };

    if (!checkoutId) {
        return (
            <div className="inqud-loader">
                <Loader/>
            </div>
        )
    }

    return (
        <div className="inqud">
            <div className="inqud-box">
                <i className="gg-close inqud-box-close-icon" onClick={_onClose}/>
                <div className="inqud-box-widget" ref={widgetRef}/>
            </div>
        </div>
    );
}

PaymentsInqud.displayName = 'PaymentsInqud';